import * as THREE from 'three';
import vertexShader from '../shaders/terrain.vertex.glsl';
import fragmentShader from '../shaders/terrain.fragment.glsl';

class Terrain {
  textureLoader = new THREE.TextureLoader();
  sideLength = 100;
  colorOne = '#455B0A';
  colorTwo = '#847e06';
  lightIntensity = 2.5;
  heightScale = 3.5;

  constructor(props) {
    this.sideLength = props.sideLength;
    this.colorOne = props.colorOne;
    this.colorTwo = props.colorTwo;
    this.lightIntensity = props.lightIntensity;
  }


  _init() {
    this.geometry = new THREE.PlaneGeometry(this.sideLength, this.sideLength, 300, 300);

    this.material = new THREE.ShaderMaterial({
      uniforms: {
        uHeightMap: new THREE.Uniform(this.textureLoader.load('./heightMap.png')),

        uHeightScale: new THREE.Uniform(3.0),
        uColorOne: new THREE.Uniform(new THREE.Color(this.colorOne)),
        uColorTwo: new THREE.Uniform(new THREE.Color(this.colorTwo)),
        uLightIntensity: new THREE.Uniform(this.lightIntensity),
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
     });
    
    
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.rotation.x = Math.PI * -0.5;

    return this.mesh;
  }
}

export default Terrain;